import { Injectable } from '@angular/core';

import * as irisIconConstants from './icon.constants';
import { IIrisIcon } from './icon.model';

@Injectable({
  providedIn: 'root'
})
export class IrisIconRegistry {
  constructor() {
    const iconObj = irisIconConstants as { [key: string]: IIrisIcon; };
    this.registerIcons(
      Object.keys(iconObj).map((key: string) => iconObj[key])
    );
  }

  private registry = new Map<string, string>();

  protected registerIcons(icons: IIrisIcon[]): void {
    icons.forEach((icon: IIrisIcon) => this.registry.set(icon.name, icon.data));
  }

  getIcon(iconName: string): string | undefined {
    if (!this.registry.has(iconName)) {
      // eslint-disable-next-line no-console
      console.warn(`We could not find an Iris Icon with the name ${iconName}, did you add it to the Icon registry?`);
    }

    return this.registry.get(iconName);
  }
}
